import { mapState } from 'vuex';
export default {
  props: {
    info: Object
  },
  computed: {
    ...mapState({
      State: state => state
    })
  },
  data() {
    return {
      tagName: ''
    };
  },
  created() {
    this.tagName = this.info.tagName;
  },
  methods: {
    cancel() {
      this.info.show = false;
    },
    deleteFn() {
      const {
        originRtilCode,
        partyCode,
        targetRtilCode
      } = this.info;
      if (!partyCode) return;
      const params = {
        mark: targetRtilCode + '',
        annotation: partyCode,
        key: 'tagName',
        notify: true,
        initiator: originRtilCode
      };
      this.axios.post('/partyline-backend/behavior/noLogin/delete', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.info.show = false;
          this.$emit('saveTagName', {
            rtilCode: targetRtilCode,
            tagName: ''
          });
        }
      });
    },
    save() {
      const tagName = this.tagName.replace(/(^\s*)|(\s*$)/g, '');
      if (!tagName) {
        return;
      }
      const {
        originRtilCode,
        partyCode,
        targetRtilCode
      } = this.info;
      if (!partyCode || !targetRtilCode) return;
      const params = [{
        mark: targetRtilCode + '',
        annotation: partyCode,
        key: 'tagName',
        value: tagName,
        notify: true,
        initiator: originRtilCode
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.info.show = false;
          this.$emit('saveTagName', {
            rtilCode: targetRtilCode,
            tagName: this.tagName
          });
        }
      });
    }
  }
};